import generic_backend_request_post from 'functions/server/generic_backend_request_post';

/**
 * Rename a saved scenario without touching its stored body (POST /rename_instance).
 *
 * rename_instance.js posts to /update_instance, which replaces the body as well
 * as the name, so it needs the scenario's full state. This is the fallback for
 * when that state cannot be had: sending anything less would overwrite the stored
 * scenario with it.
 *
 * @param {string} instanceId
 * @param {string} newName
 * @returns {Promise<boolean>}
 */
async function renameInstanceName(instanceId, newName) {
  if (!instanceId) throw new Error('Instance ID is required for renameInstanceName');
  if (!newName) throw new Error('New name is required for renameInstanceName');
  return generic_backend_request_post({ instance_id: instanceId, new_name: newName }, '/rename_instance');
}

export default renameInstanceName;
